import React from "react"
import TrayDesigner from "./TrayDesigner"
import useSearchParam from "./useSearchParam"
import { RouterPropTypes } from "./Router"
import { Redirect } from "react-router-dom"
import { RingLoader } from "./../shared/components/Spinner"
import axios from "axios"

const ACTION_TYPES = {
  STARTED: "started",
  SUCCESS: "success",
  FAILED: "failed",
}

const initialState = {
  status: "pending",
  trays: [],
  error: null,
}

function reducer(state, action) {
  switch (action.type) {
    case ACTION_TYPES.STARTED:
      return { ...state, status: "pending" }
    case ACTION_TYPES.SUCCESS:
      return { ...state, trays: action.trays, status: "resolved" }
    case ACTION_TYPES.FAILED:
      return { ...state, trays: [], status: "rejected", error: action.error }
    default:
      throw new Error()
  }
}

const Customization = ({ fetchImagesPath }) => {
  const trayVariant = useSearchParam("trayVariant")
  const [state, dispatch] = React.useReducer(reducer, initialState)

  const fetchTrays = React.useCallback(
    async variant => {
      try {
        dispatch({ type: ACTION_TYPES.STARTED })
        const {
          data: { data },
        } = await axios(fetchImagesPath, {
          method: "GET",
          params: { variant: variant.toLowerCase() },
        })

        dispatch({ type: ACTION_TYPES.SUCCESS, trays: data })
      } catch (error) {
        console.log("ERR", error)
        dispatch({ type: ACTION_TYPES.FAILED, error })
      }
    },
    [trayVariant]
  )

  React.useEffect(() => {
    if (trayVariant) {
      fetchTrays(trayVariant)
    }
  }, [trayVariant])

  const isLoading = state.status === "pending"

  if (trayVariant === null || state.error) {
    return <Redirect from="/customization" to="/" />
  }

  return (
    <div>
      <h1 className="text-capitalize text-center">{trayVariant} tray</h1>
      {isLoading ? (
        <RingLoader />
      ) : (
        <TrayDesigner
          key={trayVariant}
          isLoading={isLoading}
          trays={state.trays}
          trayVariant={trayVariant}
        />
      )}
    </div>
  )
}

Customization.propTypes = {
  ...RouterPropTypes,
}

export default Customization
